'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { SVT_FOCUS_RING } from '@eliadmin/core/src/components/ui/svetech-shape';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/** SveTech slider: #e6e8e2 track, green range, white thumb with a green border. */
const THUMB = cn(
  'block size-5 cursor-pointer rounded-full border-2 border-[#2c7a25] bg-white transition-colors hover:bg-[#eff6ed] disabled:pointer-events-none disabled:opacity-70 motion-reduce:transition-none',
  SVT_FOCUS_RING,
);

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    isDual?: boolean;
  }
>(({ className, isDual, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn('relative flex w-full touch-none select-none items-center', className)}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1 w-full grow cursor-pointer overflow-hidden rounded-full bg-[#e6e8e2]">
      <SliderPrimitive.Range className="absolute h-full bg-[#2c7a25]" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className={THUMB} />
    {isDual && <SliderPrimitive.Thumb className={THUMB} />}
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
